import { render, staticRenderFns } from "./CatalogoCambioTroquel.vue?vue&type=template&id=6a0dc596&"
import script from "./CatalogoCambioTroquel.vue?vue&type=script&lang=js&"
export * from "./CatalogoCambioTroquel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports